angular
    .module('qkr.merchant.reports')
    .value('customErrors', {});


// WEBPACK FOOTER //
// ./src/reports/value/report.customError.value.js